<template>
  <div class="letterSetting">
    <back />
    <van-form class="form">
      <van-field
        label="手机号"
        v-model="phone"
        type="tel"
        readonly
        label-class="input"
        class="field"
      />
      <van-field
        label="验证码"
        v-model="sms"
        type="number"
        placeholder="请输入验证码"
        label-class="input"
        maxlength="6"
        center
        class="field"
      >
        <template #button>
          <van-button
            plain
            size="small"
            type="default"
            round
            @click="sendVerifycode"
            :disabled="disabledCodeBtn"
            style="width:100px"
            native-type="button"
            >{{ codeText }}</van-button
          >
        </template>
      </van-field>
      <van-field
        label="新密码"
        v-model="password"
        type="password"
        label-class="input"
        maxlength="6"
        placeholder="请输入新密码"
        clearable
        class="field"
      />
      <div class="tip font-14">密码必须是6位数字</div>
      <div class="submit">
        <van-button round color="#EA5407" class="btn" @click="submit"
          >完成</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
import back from '@/components/back.vue'
import { mpCodeObj } from './common'
export default {
  components: { back },
  data() {
    return {
      id: '',
      phone: '',
      password: '',
      sms: '',
      codeText: '发送验证码',
      disabledCodeBtn: false,
      partner: ''
    }
  },
  created() {
    this.id = this.$route.query.id
    this.phone = JSON.parse(localStorage.getItem('userInfo')).mobile
    // this.phone = '13635202409'
    this.partner = JSON.parse(localStorage.getItem('userInfo')).partner
  },
  methods: {
    sendVerifycode() {
      let params = {
        mpCode: mpCodeObj[this.partner],
        telno: this.phone,
        type: '01',
        housingApartmentId: this.id
      }

      this.$api.editLetterPwdSendMsg(params).then(res => {
        if (res.code === 0) {
          this.countDown(60)
          this.$toast('已发送验证码，请注意查收！')
        } else {
          // that.$toast(res.msg)
          this.$toast(res.msg)
        }
      })
    },
    // 倒计时方法
    countDown(time) {
      if (time === 0) {
        this.disabledCodeBtn = false
        this.codeText = '发送验证码'
        return
      } else {
        this.disabledCodeBtn = true
        this.codeText = time + 's'
        time--
      }
      setTimeout(() => {
        this.countDown(time)
      }, 1000)
    },
    validator() {
      if (this.sms === '') {
        this.$toast({
          message: '验证码不能为空！',
          duration: 1000
        })
        return false
      }
      if (this.password === '') {
        this.$toast({
          message: '密码不能为空！',
          duration: 1000
        })
        return false
      }
      if (!/\d{6}/.test(this.password)) {
        this.$toast({
          message: '请输入6位数字的密码！',
          duration: 1000
        })
        return false
      }
      return true
    },
    submit() {
      if (this.validator()) {
        let params = {
          housingApartmentId: this.id,
          mobilePhone: this.phone,
          mpCode: mpCodeObj[this.partner],
          password: this.password,
          smCode: this.sms
        }
        this.$api.editLetterPwd(params).then(() => {
          this.$toast({
            type: 'success',
            message: '修改成功',
            duration: 1000,
            forbidClick: true,
            onClose: () => {
              this.$router.go(-1)
            }
          })
        })
      }
    }
  }
}
</script>

<style lang="scss">
.letterSetting {
  box-sizing: border-box;
  height: calc(100vh - 40px);
  // width: 100%;
  padding: 20px;
  position: relative;
  .input {
    width: 15%;
  }
  .field {
    background-color: #f2f2f2;
    border-bottom: 1px solid rgba(204, 204, 204, 0.7);
    padding-left: 0;
    padding-right: 0;
  }
  .tip {
    margin: 10px 0;
    color: rgba(0, 0, 0, 0.4);
  }
  .submit {
    width: 100%;
    text-align: center;
  }
  .btn {
    width: 60%;
    height: 36px;
    margin-top: 20px;
  }
}
</style>
